import React, {useState, useEffect} from 'react';
import {withTranslation} from "react-i18next";
import {Alert, Card, CardBody, Col, Modal, Row} from "reactstrap";
import paginationFactory, {PaginationListStandalone, PaginationProvider, SizePerPageDropdownStandalone} from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {Search,} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {useSelector, useDispatch} from "react-redux";
import {userNotificationsModalList} from "../../store/userNotificationsModal/actions";
import {notificationDropdownRefresh} from "../../store/layout/notificationDropdown/actions";


const UserNotificationsModal = (props) => {
  const [sizePerPage, setSizePerPage] = useState(10)
  const [dataSize, setDataSize] = useState(0)

  const {notifications, lastSeen, loading, error} = useSelector(({UserNotificationsModal}) => ({
    notifications: UserNotificationsModal.notifications,
    lastSeen: UserNotificationsModal.lastSeen,
    loading: UserNotificationsModal.loading,
    error: UserNotificationsModal.error,
  }))

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(userNotificationsModalList({history: props.history}))
    dispatch(notificationDropdownRefresh({history: props.history}))
  }, [dispatch])

  const onClose = () => {
    props.togModal()
  }

  const onSizePerPageChange = sizePerPage => {
    setSizePerPage(sizePerPage)
  }

  const onDataSizeChange = ({dataSize}) => {
    setDataSize(dataSize)
  }

  const titleFormatter = (cell, row) => {
    return (<div>
      {row.id > lastSeen && <div style={{fontWeight: 600}}>{row.title}</div>}
      {row.id <= lastSeen && <div>{row.title}</div>}
    </div>);
  }

  const messageFormatter = (cell, row) => {
    return (<div style={{whiteSpace: "pre-wrap"}}>
      {row.id > lastSeen && <div style={{fontWeight: 600}}>{row.message}</div>}
      {row.id <= lastSeen && <div>{row.message}</div>}
    </div>);
  }

  const typeFormatter = (cell, row) => {
    return (<div>
      {row.type === 0 && <div className="text-success">success</div>}
      {row.type === 1 && <div className="text-info">info</div>}
      {row.type === 2 && <div className="text-warning">warning</div>}
      {row.type === 3 && <div className="text-danger">error</div>}
    </div>);
  }

  const onColumnMatch = ({searchText, value, column, row}) => {
    if (row.title.toLowerCase().includes(searchText) || row.message.toLowerCase().includes(searchText) || row.created.toLowerCase().includes(searchText)) return true
    return false
  }

  const columns = [{
    dataField: "title", text: "Title", sort: true, formatter: titleFormatter,
  }, {
    dataField: "message", text: "Message", sort: true, formatter: messageFormatter,
  }, {
    dataField: "type", text: "Type", sort: true, formatter: typeFormatter,
  }, {
    dataField: "created", text: "Created", sort: true,
  },];

  const defaultSorted = [{
    dataField: "id", order: "desc",
  },];

  const pageOptions = {
    sizePerPage: sizePerPage, totalSize: dataSize, custom: true, onSizePerPageChange: onSizePerPageChange, sizePerPageList: [{
      text: '10', value: 10
    }, {
      text: '25', value: 25
    }, {
      text: '50', value: 50
    }]
  };

  const {SearchBar} = Search;

  return (
    <React.Fragment>
      <Modal isOpen={true} toggle={onClose} size="xl">
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            Notifications
          </h5>
          <button type="button" onClick={onClose} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <Card>
          <CardBody>
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField="id"
              columns={columns}
              data={notifications}
            >
              {({paginationProps, paginationTableProps}) => (<ToolkitProvider
                keyField="id"
                columns={columns}
                data={notifications}
                search={{onColumnMatch}}
              >
                {toolkitProps => (<React.Fragment>
                  <Row className="mb-2">
                    <Col md="8">
                    </Col>
                    <Col md="4">
                      <div className="search-box me-2 mb-2 d-inline-block float-end">
                        <div className="position-relative">
                          <SearchBar {...toolkitProps.searchProps} placeholder="Filter"/>
                          <i className="bx bx-search-alt search-icon"/>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xl="12">
                      <div className="table-responsive">
                        <BootstrapTable
                          keyField={"id"}
                          responsive
                          bordered={false}
                          striped={false}
                          defaultSorted={defaultSorted}
                          classes={"table align-middle table-nowrap"}
                          headerWrapperClasses={"thead-light"}
                          onDataSizeChange={onDataSizeChange}
                          {...toolkitProps.baseProps}
                          {...paginationTableProps}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="align-items-md-center mt-30">
                    <Col className="inner-custom-pagination d-flex">
                      <div className="d-inline">
                        <SizePerPageDropdownStandalone {...paginationProps}/>
                      </div>
                      <div className="text-md-right ms-auto">
                        <PaginationListStandalone {...paginationProps}/>
                      </div>
                    </Col>
                  </Row>
                </React.Fragment>)}
              </ToolkitProvider>)}
            </PaginationProvider>
            {loading && (<div className="d-flex justify-content-center">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>)}
            {error.length > 0 && (<div className="mt-3">
              <Alert color="danger" role="alert">
                {error}
              </Alert>
            </div>)}
          </CardBody>
        </Card>
      </Modal>
    </React.Fragment>
  )
}

export default withTranslation()(UserNotificationsModal);
